<template>
  <div :class=" `${content.from === 'guest' ?
       'gb-zb-msg gb-zb-msg-right' : 'gb-zb-choice gb-zb-msg-left' }` ">
    <a :href="content.url" :target="target">
      <img :src="content.img" v-if="content.img">
      {{ content.txt }}<link-icon />
      <span class="small">{{ content.url| domain }}</span>
    </a>
  </div>
</template>

<script>
import { LinkIcon } from 'vue-feather-icons'
import BaseMessage from '@/layout/messages/BaseMessage.vue'

export default {
  name: 'ContentUrl',
  extends: BaseMessage,
  components: { LinkIcon },
  props: {
    target: {
      type: String,
      required: false
    }
  },
  filters: {
    domain: (value) => {
      if (value.indexOf('://') > -1) {
        value = value.substr(value.indexOf('://') + 3)
      }
      if (value.indexOf('/') > -1) {
        value = value.substring(0, value.indexOf('/'))
      }
      return value
    }
  }
}

</script>

<style lang="scss" scoped>
img {
  width: 64px;
  display: block;
  position: static;
  flex: 1;
  align-self: stretch;
  height: 100%;
}

a {
  font-size: 14px;

  svg.feather {
    height: 16px;
    margin: 0 0 0 5px;
    width: 16px;
  }
}

.small {
  display: block;
  font-size: .5rem !important;
  opacity: .6;
}
</style>
